import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2 } from '@angular/core'

import { ITrack } from '../../../Interface/track'
import { CartService } from '../../../services/cart.service'
import { CurrencySignType, I18nService } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-track-item-box',
  templateUrl: './bmcore-track-item-box.component.html',
  styleUrls: ['./bmcore-track-item-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackItemBoxComponent implements OnInit {
  @Input() track: ITrack
  @Input() tracks: ITrack[] // needed to set up a playlist

  currencySign: CurrencySignType

  constructor(
    private renderer: Renderer2,
    private i18nService: I18nService,
    protected cartService: CartService
  ) {}

  ngOnInit(): void {
    this.currencySign = this.i18nService.getCurrencySign()
  }

  wantToAddBeat(event: MouseEvent, beatId: number) {
    event.stopPropagation()
    this.renderer.addClass(document.body, 'modal-open')
    this.cartService.wantAddBeat(beatId)
  }
}
